<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-wrapper">
      <button @click="close" class="modal-close">×</button>
      <div class="modal-body">
        <div id="modal-online-scheduling">
          <page-online-scheduling :dealer-id="dealerId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import pageOnlineScheduling from '../../pages/online-scheduling.vue';
import createStore from "../../store/create-store";
import { mapActions } from "vuex";
import scrollPageToTop from '../../scroll-page-to-top';

const getClinicUrlSlug = (clinicUrl) => {
  if (!clinicUrl) return null;

  const segments = String(clinicUrl).split('/').filter(Boolean);
  return segments[segments.length - 1] || null;
};

export default {
  components: {
    pageOnlineScheduling,
  },
  props: {
    dealerId: {
      type: String,
      required: true,
    },
    clinicUrl: {
      type: String,
      default: null,
    }
  },
  methods: {
    ...mapActions('OnlineScheduling', { resetData: 'resetData' }),
    close() {
      this.resetData();
      document.body.style.overflow = '';

      const el = this.$el;
      this.$destroy();

      if (el && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  },

  open(props = {}) {
    const modalStore = createStore();
    modalStore.dispatch('OnlineScheduling/resetData');
    modalStore.dispatch('Globals/setLoadedDate');

    const clinicUrl = getClinicUrlSlug(props.clinicUrl);
    if (clinicUrl) {
      modalStore.commit('OnlineScheduling/setStateValue', { key: 'clinicUrl', value: clinicUrl });
    }

    let el = document.createElement('div');
    document.body.appendChild(el);

    const ModalClass = Vue.extend(this);
    const modalInstance = new ModalClass({
      store: modalStore,
      propsData: props,
    });

    modalInstance.$mount(el);
    document.body.style.overflow = 'hidden';
    scrollPageToTop();

    return modalInstance;
  }
};
</script>

<style>
.modal-overlay {
  position: fixed;
  inset: 0;
  height: 100vh;
  height: 100dvh;
  background: rgba(6,88,148,0.8)!important;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  overflow: hidden;
}
@media (max-width: 575px) {
  .modal-overlay {
    padding: 1rem;
  }
}
.modal-wrapper {
  display: flex;
  flex-direction: column;
  background: white;
  padding: 20px;
  position: relative;
  width:100%;
  height: calc(100vh - 4rem);
  height: calc(100dvh - 4rem);
  max-width: 64rem;
  max-height: calc(100vh - 4rem);
  max-height: calc(100dvh - 4rem);
}
@media (max-width: 575px) {
  .modal-wrapper {
    height: calc(100vh - 2rem);
    height: calc(100dvh - 2rem);
    max-height: calc(100vh - 2rem);
    max-height: calc(100dvh - 2rem);
  }
}
.modal-close {
  position: absolute;
  top: -.5rem;
  right: -0rem;
  margin-left: auto;
  font-size: 2rem;
  border: none;
  background: none;
  cursor: pointer;
  color: #e5231b;
  height: 2.5rem;
  line-height: 1;
  z-index: 2;
  transition: ease .35s;
  &:hover {
    transform: scale(1.1);
  }
}
.modal-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
</style>
